"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetType = void 0;
var TargetType;
(function (TargetType) {
    TargetType["BLANK"] = "_blank";
    TargetType["SELF"] = "_self";
    TargetType["TOP"] = "_blank";
    TargetType["PARENT"] = "_parent";
})(TargetType = exports.TargetType || (exports.TargetType = {}));
//# sourceMappingURL=LinkProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Link/LinkProps.js
// module id = 556
// module chunks = 8